<shrd-pf-ft-marketing-banners />

<ng-container *ngIf="footerLinks$ | async as links">
  <ng-container *ngIf="!{ compressed: compressed$ | async }.compressed; else compressedTpl">
    <div class="bg-neutral-megalight d-print-none">
      <div class="container-fluid mb-0">
        <div class="row">
          <div class="col">
            <div class="content-box link-columns">
              <shrd-pf-ui-links-column-accordion
                *ngIf="links.footerContact as contactLinks"
                [sectionTitle]="'header.meta.contact' | i18next"
                [links]="contactLinks"
                [isLast]="!links.moSpecificColumns?.length"
              />
              <ng-container *ngIf="links.moSpecificColumns as moSpecificCols">
                <shrd-pf-ui-links-column-accordion
                  *ngFor="let column of moSpecificCols; last as isLast"
                  [sectionTitle]="column.title"
                  [links]="column.childList"
                  [isLast]="isLast"
                />
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt-2 mb-1 d-print-none">
      <div class="row">
        <div class="col col-24 col-md-18">
          <div class="content-box">
            <shrd-pf-ui-logo [small]="true" />
          </div>
          <ng-template [ngTemplateOutlet]="legalLinksTpl" />
        </div>

        <div *ngIf="links.socialMediaIcons as icons" class="col col-24 col-md-6 mt-1 mt-md-0">
          <div class="content-box">
            <p class="text-bold mb-0">{{ icons.title }}</p>
            <div class="my-md-1">
              <a
                *ngFor="let link of icons.childList"
                shrdUicButton
                variant="tertiaryMinorBorderless"
                class="my-0"
                [href]="link.url"
                target="_blank"
                [attr.aria-label]="link.title"
              >
                <shrd-uic-svg-icon [icon]="link.type" [size]="sizeOption.SMALL" [inheritColor]="true" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *shrdUtcFeatureToggleOn="'ldt_ngc_hdms_print_header_footer'">
    <shrd-ft-footer-print-layout *shrdUtcIfPlatformBrowser />
  </ng-container>

  <ng-template #compressedTpl>
    <div class="bg-neutral-megalight">
      <div class="container-fluid mb-0">
        <div class="row">
          <div class="col">
            <ng-template [ngTemplateOutlet]="legalLinksTpl" />
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #legalLinksTpl>
    <div class="content-box">
      <ul class="basic-link-container no-markers">
        <li class="pe-3" *ngFor="let link of links.legalLinks">
          <a [href]="link.url" shrdUtcAutoTarget class="basic-link">{{ link.title }}</a>
        </li>
      </ul>
    </div>
  </ng-template>
</ng-container>

<nav *ngIf="isServer" shrd-pf-ft-menu-seo-only-links [primaryNavItems]="primaryLinks$ | async"></nav>
